import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: 'products',
  initialState: [],
  reducers: {
    productReducer: {
      reducer: (state, action) => (state = action.payload),
      prepare: (value) => ({ payload: value || [] }),
    },
  },
});

export const { productReducer } = productSlice.actions;
export default productSlice.reducer;

